<template>
  <div>
    <Breadcrumb :options="breadcrumb" />
    
    <div class="mainss">
      <div class="left">
        <el-steps direction="vertical">
          <el-step :title="c.title" v-for="(c, i) in remarks" :key="'remark' + i">
            <template slot="description">
              <div class="cons">
                <!-- <div class="tit">{{ c.title }}</div> -->
                <div class="word">
                  {{ c.content }}
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'syslog',
      breadcrumb: [
        { name: "帮助中心", path: `` },
        { name: "更新日志" },
      ],
      getOptionUrl: 'index',
      remarks: [],
    };
  },
  methods: {
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/rec`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ data }) => {
        if (data) {
          // this.detail = data
          // this.setDetail()
          this.remarks = data
          // console.log('有数据了', data.tradeid, typeof data.tradeid)
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
.mainss {
  display: flex;
  justify-content: space-between;

  .left {
    // width: 48.5%;
    width: 100%;
    padding: 20px 0 20px 25px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.03);
    border-radius: 5px 5px 5px 5px;

    /deep/.el-steps {

      .el-step__icon.is-text {
        background: #2691FF;
        border: 0;
      }

      .el-step__icon {
        width: 12px;
        height: 12px;
      }

      .is-vertical .el-step__line {
        width: 2px;
        top: 15px;
        bottom: 0px;
        left: 5px;
      }

      .el-step__line {
        background: #E6E8EB;
      }

      .el-step__icon-inner {
        display: none;
      }

      .is-vertical .el-step__head {
        padding-top: 4px;
        flex-grow: 0;
        width: 14px;
      }

      .el-step__title {
        font-size: 15px;
        font-weight: 400;
        color: #303133;
      }
      .el-step__description {
        padding-right: 0;
      }
    }

    .cons {
      width: 96%;
      margin: 10px 0;
      padding: 15px 20px;
      background: #F7F7F7;
      border-radius: 5px;
      opacity: 1;

      .tit {
        font-size: 15px;
        font-weight: 400;
        color: #909399;
      }

      .word {
        //margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #303133;
      }
    }
  }

  .right {
    width: 49%;
  }
}

/deep/ .el-form {
  background-color: #fff;
  padding: 25px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-textarea__inner {
    height: 100px;
    background: #F7F8FA;
    border: none;
    // color: #909399;
    font-family:"Microsoft Yahei";
    font-size: 14px;
  }


}

.btns {
  margin: 25px 0 20px 25px;
  // margin: 0 auto;
}
</style>
